import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M19.25 18V6C19.25 5.30964 18.6904 4.75 18 4.75H6C5.30964 4.75 4.75 5.30964 4.75 6V18C4.75 18.6904 5.30964 19.25 6 19.25H8.65766L9.51577 16.6757M9.51577 16.6757L11.8243 9.75H12.3784L14.6869 16.6757L15.6386 19.5305C15.681 19.658 15.7027 19.7915 15.7027 19.9258V20M14.6869 16.6757H9.51577" vectorEffect="non-scaling-stroke" />
	</SVG>
);
